import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, MenuItem, TextField, Switch, FormControlLabel, Chip, Avatar } from '@mui/material';
import { Edit, Person } from '@mui/icons-material';
import { useAppData } from '../../../../../../context/AppDataContext';

const AssigneeBadge = ({ value, callBack }) => {
    const [dialogStatus, setDialogStatus] = useState(false);
    const [inputAssignee, setInputAssignee] = useState(value);
    const [notify, setNotify] = useState(false);
    const [remark, setRemark] = useState("");

    const { userDD,getDDDataById } = useAppData();

    // Assuming your user master is under 'users' or 'employees'
    const userList = userDD || []; 
    const currentName = getDDDataById(userDD, value)?.label || "Unassigned";

    const handleUpdate = () => {
        if (callBack) {
            callBack({
                assignedTo: inputAssignee,
                notify: notify,
                remark: remark
            });
        }
        setDialogStatus(false);
        setRemark("");
    };

    return (
        <>
            <Chip 
                // Display User Icon/Avatar and Name
                avatar={<Avatar sx={{ width: 24, height: 24 }}><Person fontSize="small" /></Avatar>}
                label={currentName}
                onClick={callBack ? () => setDialogStatus(true) : undefined}
                onDelete={callBack ? () => setDialogStatus(true) : undefined}
                deleteIcon={callBack ? <Edit style={{ fontSize: '14px' }} /> : null}
                variant="outlined"
                sx={{ 
                    fontWeight: 'bold',
                    cursor: callBack ? 'pointer' : 'default',
                    backgroundColor: '#f8f9fa',
                    '& .MuiChip-label': { px: 1 }
                }} 
            />

            {callBack && (
                <Dialog
                    open={dialogStatus}
                    onClose={() => setDialogStatus(false)}
                    fullWidth={true}
                    maxWidth="xs"
                >
                    <div className='p-3 fw-bold border-bottom'>Reassign Task</div>
                    <DialogContent>
                        <div className='row mt-2'>
                            <div className='col-md-12'>
                                {/* User Selection */}
                                <TextField
                                    select
                                    fullWidth
                                    label="Select Assignee"
                                    value={inputAssignee}
                                    onChange={(e) => setInputAssignee(e.target.value)}
                                    margin="normal"
                                >
                                    {userList.map((user) => (
                                        <MenuItem key={user.value} value={user.value}>
                                            {user.label}
                                        </MenuItem>
                                    ))}
                                </TextField>

                                {/* Remark */}
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={2}
                                    label="Handover Note / Remark"
                                    value={remark}
                                    onChange={(e) => setRemark(e.target.value)}
                                    margin="normal"
                                    placeholder="Optional note for the new assignee"
                                />

                                {/* Notification Toggle */}
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={notify}
                                            onChange={(e) => setNotify(e.target.checked)}
                                        />
                                    }
                                    label="Notify new assignee via Email"
                                />
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions className="p-3">
                        <button className='btn btn-light' onClick={() => setDialogStatus(false)}>Cancel</button>
                        <button className='btn btn-primary' onClick={handleUpdate}>Assign Task</button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
};

export default AssigneeBadge;